import {get} from 'svelte/store';
import {onDocumentLoaded} from '$lib/core/utils/web/hooks.js';
import {dev, version} from '$app/environment';
import {PUBLIC_ENABLE_SW_IN_DEV} from '$env/static/public';
import {serviceWorker} from '$lib';

import {logs} from 'named-logs';

const logger = logs('init');

logger.debug(`initialization...`);

export const prerender = true;
export const trailingSlash = 'always';
export const ssr = true;

console.log(`VERSION: ${version}`);

// The service worker is registered in production. In dev it is skipped by
// default so HMR/reloads are not intercepted by the SW cache; set
// PUBLIC_ENABLE_SW_IN_DEV=true to opt in when developing the SW itself
// (push notifications, update flow, offline).
const enableSwInDev = PUBLIC_ENABLE_SW_IN_DEV === 'true';
if (!dev || enableSwInDev) {
	if (dev) {
		console.warn(
			`registering service-worker in dev mode (PUBLIC_ENABLE_SW_IN_DEV=true); HMR and reloads may be intercepted by the SW cache`,
		);
	}
	onDocumentLoaded(serviceWorker.register);
} else {
	console.warn(
		`skipping service-worker registration in dev mode, see src/routes/+layout.ts (set PUBLIC_ENABLE_SW_IN_DEV=true to enable)`,
	);
}

// Dev/debug: attaching svelte store get() for console access
(globalThis as any).get = get;
